<!--
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version: 
 * @Author: Duanshuai
 * @Date: 2022-01-24 15:17:15
 * @LastEditors: ------
 * @LastEditTime: 2022-02-25 11:32:52
-->
<template>
  <div class="lookCon">
    <van-nav-bar
      title="创建意向单"
      left-text="返回"
      fixed
      left-arrow
      placeholder
      @click-left="$router.push('/')"
    />
    <div class="NurseDetail">
      <div class="form">
        <van-field
          v-model="formData.name"
          name="姓名"
          label="姓名"
          required
          placeholder="请填写姓名"
          input-align="right"
        />
        <van-field
          readonly
          clickable
          required
          label="性别"
          :value="value || formData.sex_dictText"
          placeholder="选择性别"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <van-field
          v-model="formData.age"
          
          name="年龄"
          label="年龄"
          placeholder="请填写年龄"
          input-align="right"
        />
        <van-field
          v-model="formData.idCard"
          name="医保卡"
          label="医保卡"
          maxlength="20"
          required
          placeholder="医保卡"
          input-align="right"
          :rules="[{ required: true, message: '请填写医保卡号' }, { validator: this.validateIdCard, message: '不允许输入身份证号' }]"
        />
        <van-field
          readonly
          clickable
          label="需求服务类型"
          :value="value1 || formData.nurseType_dictText"
          placeholder="选择服务类型"
          @click="showPicker1 = true"
          required
          :rules="[{ required: true }]"
        />
        <van-popup v-model="showPicker1" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns1"
            @cancel="showPicker1 = false"
            @confirm="onConfirm1"
          />
        </van-popup>
        <div class="price" v-if="value1 && showPicker9">
          <van-field
            readonly
            clickable
            label="协商价格"
            :value="value8"
            :placeholder="columns8"
            @click="showPicker8 = true"
            required
            :rules="[{ required: true }]"
          />
        
            
          <div class="div_price">
            <van-field v-model="formData.negotiatePrice" type="digit" center />
          </div>
        </div>
        <div class="price" v-if="value1 && showPicker10">
          <!-- <van-cell title="选择单个日期" bind:click="onDisplay" /> -->
        
            
        </div>
        <van-field
          readonly
          clickable
          required
          label="绑定门店"
          :value="value9 || formData.store"
          placeholder="选择门店"
          @click="showPicker11 = true"
        />
        <van-popup v-model="showPicker11" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns9"
            @cancel="showPicker11 = false"
            @confirm="onConfirm9"
          />
        </van-popup>
        <van-field
          v-model="formData.serviceDetailAddress"
          name="服务地址"
          label="服务地址"
          placeholder="请填写服务地址"
          input-align="right"
          required
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="formData.mobile"
          name="客户联系电话"
          label="客户联系电话"
          type="tel"
          maxlength="11"
          required
          placeholder="请填写客户联系电话"
          input-align="right"
        />
      </div>
      <!-- <div class="form">
        <van-field
          v-model="formData.serviceRequire"
          autosize
          
          label="服务详情要求"
          type="textarea"
          placeholder="请输入服务详情要求"
        />
        <van-field
          v-model="formData.specialRequire"
          autosize
          
          label="服务人员特殊要求"
          type="textarea"
          placeholder="请输入服务人员特殊要求"
        />
        <van-field
          v-model="formData.notice"
          autosize
          
          label="护理要点和须知"
          type="textarea"
          placeholder="请输入护理要点和须知"
        />
        <van-field
          v-model="formData.remark"
          autosize
          
          label="备注"
          type="textarea"
          placeholder="请输入备注"
        />
      </div>
      <div class="form">
        <van-field
          v-model="formData.getUpNum"
          name="起夜情况"
          label="起夜情况"
          placeholder="次数"
          input-align="right"
        />
        <van-field
          v-model="formData.height"
          name="身高"
          label="身高"
          type="number"
          maxlength="3"
          placeholder="厘米"
          input-align="right"
        />
        <van-field
          v-model="formData.weight"
          name="体重"
          label="体重"
          type="number"
          maxlength="3"
          placeholder="公斤"
          input-align="right"
        />
        <van-field
          readonly
          clickable
          label="是否需要做饭"
          :value="value5 || formData.needCook_dictText"
          placeholder="是否需要做饭"
          @click="showPicker5 = true"
        />
        <van-popup v-model="showPicker5" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns5"
            @cancel="showPicker5 = false"
            @confirm="onConfirm5"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          label="服务人员是否住宿"
          :value="value6 || formData.needStay_dictText"
          placeholder="服务人员是否住宿"
          @click="showPicker6 = true"
        />
        <van-popup v-model="showPicker6" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns6"
            @cancel="showPicker6 = false"
            @confirm="onConfirm6"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          label="有无长护险"
          :value="value4 || '无'"
          placeholder="有无长护险"
          @click="showPicker4 = true"
        />
        <van-popup v-model="showPicker4" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns4"
            @cancel="showPicker4 = false"
            @confirm="onConfirm4"
          />
        </van-popup>
        <div
          v-if="
            formData.medicalInsuranceFlag && formData.medicalInsuranceFlag == 10
              ? true
              : false
          "
        >
          <van-field
            readonly
            clickable
            label="长护险等级"
            :value="
              value2 ||
              (formData.medicalInsuranceLevel == 1
                ? '一级'
                : formData.medicalInsuranceLevel == 2
                ? '二级'
                : formData.medicalInsuranceLevel == 3
                ? '三级'
                : formData.medicalInsuranceLevel == 4
                ? '四级'
                : formData.medicalInsuranceLevel == 5
                ? '五级'
                : '六级')
            "
            placeholder="选择长护险等级"
            @click="showPicker2 = true"
          />
          <van-popup v-model="showPicker2" round position="bottom">
            <van-picker
              show-toolbar
              :columns="columns2"
              @cancel="showPicker2 = false"
              @confirm="onConfirm2"
            />
          </van-popup>
        </div>

        <van-field
          v-model="formData.familyNum"
          name="家中人数"
          label="家中人数"
          type="digit"
          placeholder="如：2"
          input-align="right"
        />

        <van-popup v-model="showPicker1" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns1"
            @cancel="showPicker1 = false"
            @confirm="onConfirm1"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          label="服务人员护理周期"
          :value="value3 || formData.medicalInsuranceCycle_dictText"
          placeholder="选择护理周期"
          @click="showPicker3 = true"
        />
        <van-popup v-model="showPicker3" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns3"
            @cancel="showPicker3 = false"
            @confirm="onConfirm3"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          label="是否接受节假日 另议价格"
          :value="value7 || formData.needStay_dictText"
          placeholder="请选择"
          @click="showPicker7 = true"
        /> 
        <van-popup v-model="showPicker7" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns7"
            @cancel="showPicker7 = false"
            @confirm="onConfirm7"
          />
        </van-popup>
      </div>
      -->

      <div class="btn">
        <van-button round block type="info" @click="submmit"
          >生成意向单</van-button
        >
      </div>
      <div class="title"></div>
    </div>
  </div>
</template>

<script>
import { addInterview } from "@/api";
import { Toast, Dialog } from "vant";
export default {
  name: "",
  data() {
    return {
      formData: {
        // name: JSON.parse(this.$route.query.obj).name || "",
        // age: JSON.parse(this.$route.query.obj).age || "",
        // accountFamilyMemberId: JSON.parse(this.$route.query.obj).id || "",
      },
      message: "",
      value: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      
      value9: "",
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      showPicker6: false,
      showPicker7: false,
      showPicker8: false,
      showPicker9: true,
      showPicker10: false,
      
      showPicker11: false,
      columns: ["男", "女"],
      columns1: ["24小时居家服务", "日间陪护", "夜间陪护","分时照护","医院陪护","长护险新增","长护险旧客新增","长护险转入","残联服务","民政服务","长护险服务" ],
      // columns1: ["长护险新增","长护险旧客新增","长护险转入"],
      columns2: ["一级", "二级", "三级", "四级", "五级", "六级"],
      columns3: ["做六休一", "半月一休", "无休"],
      columns4: ["有", "无"],
      columns5: ["是", "否"],
      columns6: ["是", "否"],
      columns7: ["是", "否"],
      columns8: "协商价格",
      columns9: ["德心居护理站", "艾高护护理站", "艾禹护护理站", "沪东护理站","艾悦护理站",
                "北蔡为老服务中心","住家照护部","抚顺爱介护养老服务有限公司","北京爱介护养老服务有限公司","供应链","其他门店","爱乐护",
                "上海爱介护居家养老服务有限公司","南京江宁宁帛护理服务有限公司","新沪东","淮安爱介护居家养老服务有限公司","特护部","爱介护（吉林）居家养老有限公司",
                "东海护理院护工部","上海浦东新区养尊无忧养老服务中心","济南善佳爱介护","柳州爱介护护理站有限公司","残联项目-北蔡张江","残联项目-川沙","残联项目-东明",
                "残联项目-三高","残联项目-三林","残联项目-上南","残联项目-祝桥","民政艾高护","民政沪东","互利佳养老院管理部","酒泉护理护工部","爱介护(昆明)健康科技有限公司",
                "迪吉健康","迪季培训","爱介护(辽宁)居家养老科技服务有限公司","上海艾博智护数字科技有限公司"],
    };
  },
  created() {},
  methods: {
    // 身份证号验证方法
    validateIdCard(value) {
      // 身份证号正则表达式（15位或18位）
      const idCardPattern = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
      // 如果输入的是身份证号，返回false表示验证失败
      return !idCardPattern.test(value);
    },
    submmit() {
      let info = JSON.parse(localStorage.getItem("info"));
      this.formData.salesman = info.id;
      this.formData.salesName = info.realname;
      this.formData.emType=1;

      if (!this.formData.name) {
        Toast("请填写用户姓名!");
        return false;
      }
      this.formData.name = this.formData.name.replace(/\s*/g,"")
      if (!this.formData.nurseType) {
        Toast("请填写服务类型!");
        return false;
      }
      if (!this.formData.mobile) {
        Toast("请填写联系电话!");
        return false;
      }
      if (!this.formData.idCard) {
        Toast("请填写医保卡号!");
        return false;
      }
      // 添加身份证号验证
      const idCardPattern = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
      if (idCardPattern.test(this.formData.idCard)) {
        Toast("不允许输入身份证号，请填写医保卡号!");
        return false;
      }
      // if (!this.formData.idCard) {
      //   Toast("请填写身份证号或医保卡号!");
      //   return false;
      // }
      
      console.log('1',this.formData.store);
      if (!this.formData.store ) {
        Toast("请填写门店选项!");
        return false;
      }
      // if (!this.formData.serviceRequire) {
      //   //校验服务详情要求
      //   Toast("请填写服务详情要求!");
      //   return false;
      // }
      // if (!this.formData.specialRequire) {
      //   //校验服务人员特殊要求
      //   Toast("请填写服务人员特殊要求!");
      //   return false;
      // }
      // if (!this.formData.notice) {
      //   //校验护理要点和须知
      //   Toast("请填写护理要点和须知!");
      //   return false;
      // }
      console.log(this.formData);
      // return
      
      addInterview(this.formData).then((res) => {
        // console.log(res);
        if (res.data.success) {
          Dialog.alert({
            message: res.data.message,
          }).then(() => {
            // on confirm
            this.$router.push("/customer");
          });
        } else {
          Dialog.alert({
            message: res.data.message,
          });
        }
      });
    },
    onConfirm9(value) {
      this.value9 = value;
      this.showPicker11 = false;
      // if (value == "艾禹护护理站") {
      //   this.formData.store = 1;
      // } else if (value == "德心居护理站") {
      //   this.formData.store = 2;
      // }else if (value == "沪东护理站") {
      //   this.formData.store = 3;
      // }else if (value == " 艾悦护理站") {
      //   this.formData.store = 5;
      // }else{
      //   this.formData.store = 4;
      // }

      if (value == "艾禹护护理站") {
        this.formData.store = 1;
      } else if (value == "德心居护理站") {
        this.formData.store = 2;
      }else if (value == "沪东护理站") {
        this.formData.store = 3;
      }else if (value == "艾高护护理站") {
        this.formData.store = 4;
      }else if (value == "艾悦护理站") {
        this.formData.store = 5;
      }else if (value == "淮安爱介护居家养老服务有限公司") {
        this.formData.store = 6;
      }else if (value == "民政沪东") {
        this.formData.store = 7;
      }else if (value == "残联项目-北蔡张江") {
        this.formData.store = 8;
      }else if (value == "残联项目-东明") {
        this.formData.store = 9;
      }else if (value == "爱乐护") {
        this.formData.store = 10;
      }else if (value == "柳州爱介护护理站有限公司") {
        this.formData.store = 11;
      }else if (value == "残联项目-川沙") {
        this.formData.store = 12;
      }else if (value == "酒泉护理护工部") {
        this.formData.store = 13;
      }else if (value == "残联项目-祝桥") {
        this.formData.store = 14;
      }else if (value == "迪季培训") {
        this.formData.store = 15;
      }else if (value == "残联项目-三林") {
        this.formData.store = 16;
      }else if (value == "迪吉健康") {
        this.formData.store = 17;
      }else if (value == "北京爱介护养老服务有限公司") {
        this.formData.store = 18;
      }else if (value == "特护部") {
        this.formData.store = 19;
      }else if (value == "住家照护部") {
        this.formData.store = 20;
      }else if (value == "其他门店") {
        this.formData.store = 21;
      }else if (value == "抚顺爱介护养老服务有限公司") {
        this.formData.store = 22;
      }else if (value == "爱介护(辽宁)居家养老科技服务有限公司") {
        this.formData.store = 23;
      }else if (value == "南京江宁宁帛护理服务有限公司") {
        this.formData.store = 24;
      }else if (value == "供应链") {
        this.formData.store = 25;
      }else if (value == "民政艾高护") {
        this.formData.store = 26;
      }else if (value == "残联项目-三高") {
        this.formData.store = 27;
      }else if (value == "上海艾博智护数字科技有限公司") {
        this.formData.store = 28;
      }else if (value == "上海爱介护居家养老服务有限公司") {
        this.formData.store = 29;
      }else if (value == "爱介护（吉林）居家养老有限公司") {
        this.formData.store = 30;
      }else if (value == "北蔡为老服务中心") {
        this.formData.store= 31;
      }else if (value == "互利佳养老院管理部") {
        this.formData.store = 32;
      }else if (value == "东海护理院护工部") {
        this.formData.store = 33;
      }else if (value == "上海浦东新区养尊无忧养老服务中心") {
        this.formData.store = 34;
      }else if (value == "爱介护(昆明)健康科技有限公司") {
        this.formData.store = 35;
      }else if (value == "新沪东") {
        this.formData.store = 36;
      }else if (value == "济南善佳爱介护") {
        this.formData.store = 37;
      }else if (value == "残联项目-上南") {
        this.formData.store = 38;
      }
      console.log('门店',this.formData.store);
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
      if (value == "男") {
        this.formData.sex = 1;
      } else {
        this.formData.sex = 2;
      }
    },
    onConfirm1(value) {
      
      this.showPicker9 = true;
      this.showPicker10 = false;
      this.value1 = value;
      this.showPicker1 = false;
      this.columns8 = "";
      this.value8 = "";
      if (value == "24小时居家服务") {
        this.formData.nurseType = 12;
        this.columns8 = "元/月"
      }
      if (value == "日间陪护") {
        this.formData.nurseType = 18;
      
        this.columns8="元/月"
      }
      if (value == "夜间陪护") {
        this.formData.nurseType = 19;
     
        this.columns8="元/月"
      }
      if (value == "分时照护") {
        this.formData.nurseType = 11;
       
        this.columns8="元/小时"
      }
      if (value == "医院陪护") {
        this.formData.nurseType = 13;
      
        this.columns8="元/天"
      }
       if (value == "医院陪护") {
        this.formData.nurseType = 13;
      
        this.columns8="元/天"
      }
       if (value == "长护险新增") {
        this.formData.nurseType = 20;
        this.showPicker9 = false;
        this.showPicker10 = true;
      
      }
      if (value == "长护险旧客新增") {
        this.formData.nurseType = 21;
        this.showPicker9 = false;
        this.showPicker10 = true;
      
      } 
      if (value == "长护险转入") {
        this.formData.nurseType = 22;
        this.showPicker9 = false;
        this.showPicker10 = true;
      
      }
      if (value == "残联服务") {
        this.formData.nurseType = 24;
        this.showPicker9 = false;
        this.showPicker10 = true;
      }
      if (value == "民政服务") {
        this.formData.nurseType = 25;
        this.showPicker9 = false;
        this.showPicker10 = true;
      }
      if (value == "长护险服务") {
        this.formData.nurseType = 26;
        this.showPicker9 = false;
        this.showPicker10 = true;
      }
      console.log('需求',this.formData.nurseType);
      this.onConfirm8();
    },
    onConfirm2(value) {
      this.value2 = value;
      this.showPicker2 = false;
      if (value == "一级") return (this.formData.medicalInsuranceLevel = 1);
      if (value == "二级") return (this.formData.medicalInsuranceLevel = 2);
      if (value == "三级") return (this.formData.medicalInsuranceLevel = 3);
      if (value == "四级") return (this.formData.medicalInsuranceLevel = 4);
      if (value == "五级") return (this.formData.medicalInsuranceLevel = 5);
      if (value == "六级") return (this.formData.medicalInsuranceLevel = 6);
    },
    onConfirm3(value) {
      this.value3 = value;
      this.showPicker3 = false;
      if (value == "做六休一") return (this.formData.medicalInsuranceCycle = 1);
      if (value == "半月一休") return (this.formData.medicalInsuranceCycle = 2);
      if (value == "无休") return (this.formData.medicalInsuranceCycle = 3);
    },
    onConfirm4(value) {
      this.value4 = value;
      this.showPicker4 = false;
      console.log(this.value4, "00000");
      if (value == "有") return (this.formData.medicalInsuranceFlag = 10);
      if (value == "无") {
        this.formData.medicalInsuranceFlag = 11;
      }
      // this.$forceUpdate();
    },
    onConfirm5(value) {
      if (value == "需要") {
        this.formData.needCook = 10;
      } else {
        this.formData.needCook = 11;
      }
      this.value5 = value;
      this.showPicker5 = false;
    },
    onConfirm6(value) {
      if (value == "是") {
        this.formData.needStay = 10;
      } else {
        this.formData.needStay = 11;
      }
      this.value6 = value;
      this.showPicker6 = false;
    },
    onConfirm7(value) {
      if (value == "是") {
        this.formData.needStay = 10;
      } else {
        this.formData.needStay = 11;
      }
      this.value7 = value;
      this.showPicker7 = false;
    },
    onConfirm8() {
      let value= this.columns8;
      if (value == "元/月") return (this.formData.emType = 1);
      if (value == "元/天") return (this.formData.emType = 2);
      if (value == "元/小时") return (this.formData.emType = 3);
    },
  },
};
</script>

<style scoped lang="less">
.lookCon {
  background: #f0efef;
  height: 100vh;
  .form {
    margin: 10px 0;
  }
  /deep/ .van-cell__title {
    width: 140px;
  }
}
/deep/ .van-nav-bar {
  background: linear-gradient(-90deg, #1ed59c, #22d59d);

  .van-nav-bar__title {
    color: #fff;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon,
  .van-nav-bar__text {
    color: #fff;
  }
}
/deep/ .van-field__control {
  text-align: right;
}
.btn {
  margin: 16px;

  /deep/ .van-button {
    background: linear-gradient(-90deg, #0ecde1, #2bd79f);
  }
}
.price {
  position: relative;
  .div_price {
    position: absolute;
    top: 0;
    right: 100px;
    width: 140px;
    /deep/ .van-cell .van-field__control {
      border: 1px solid #ccc;
    }
  }
}
</style>
